import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';

const comparisons = [
  { bad: 'Generic support replies',           good: 'Answers tailored to your business workflows and brand identity'              },
  { bad: 'Only understands public FAQs',      good: 'Understands internal docs, SOPs, and support content'    },
  { bad: 'Users hunt through articles',       good: 'Users get direct, conversational answers'                },
  { bad: 'One-size-fits-all responses',       good: 'Context-aware assistance'                                },
  { bad: 'Keyword matching',                  good: 'Understands intent and meaning'                          },
];

function Bubble({ text, type }) {
  return (
    <div style={{
      padding: '10px 14px', borderRadius: 12, fontSize: 13, lineHeight: 1.5, marginBottom: 10,
      background: type === 'bad' ? 'rgba(239,68,68,0.08)' : 'rgba(34,211,238,0.08)',
      border: type === 'bad' ? '1px solid rgba(239,68,68,0.25)' : '1px solid rgba(34,211,238,0.25)',
      color: type === 'bad' ? '#fca5a5' : '#a5f3fc',
      display: 'flex', alignItems: 'flex-start', gap: 10,
    }}>
      {type === 'bad'
        ? <XCircle size={16} color="#ef4444" style={{ flexShrink: 0, marginTop: 2 }} />
        : <CheckCircle2 size={16} color="#22d3ee" style={{ flexShrink: 0, marginTop: 2 }} />}
      {text}
    </div>
  );
}

export default function ProblemSolution() {
  return (
    <section id="see-the-difference" style={{ padding: '100px 24px', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 600, height: 300, background: 'rgba(71,158,195,0.06)', borderRadius: '50%', filter: 'blur(80px)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: 1100, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
          style={{ textAlign: 'center', marginBottom: 64 }}>
          <p style={{ fontSize: 13, color: '#479EC3', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 12 }}>See The Difference</p>
          <h2 style={{ fontSize: 'clamp(28px, 4vw, 48px)', fontWeight: 800, lineHeight: 1.15, marginBottom: 16, letterSpacing: '-0.02em' }}>
            Same question. Completely<br />different experience.
          </h2>
          <p style={{ fontSize: 18, color: '#64748b', maxWidth: 560, margin: '0 auto' }}>
            Scripted bots hit a wall the moment customers go off-script. Pulse handles the unexpected — naturally.
          </p>
        </motion.div>

        <div className="ps-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
          {/* Traditional */}
          <motion.div initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
            style={{ background: 'rgba(239,68,68,0.04)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 16, padding: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
              <XCircle size={22} color="#ef4444" />
              <h3 style={{ fontSize: 18, fontWeight: 700, color: '#fca5a5' }}>Traditional Chatbot</h3>
            </div>
            {comparisons.map((c, i) => <Bubble key={i} text={c.bad} type="bad" />)}
          </motion.div>

          {/* Pulse */}
          <motion.div initial={{ opacity: 0, x: 24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
            style={{ background: 'rgba(34,211,238,0.04)', border: '1px solid rgba(34,211,238,0.2)', borderRadius: 16, padding: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
              <CheckCircle2 size={22} color="#22d3ee" />
              <h3 style={{ fontSize: 18, fontWeight: 700, color: '#a5f3fc' }}>Pulse AI Assistant</h3>
            </div>
            {comparisons.map((c, i) => <Bubble key={i} text={c.good} type="good" />)}
          </motion.div>
        </div>
      </div>

      <style>{`
        @media (max-width: 700px) { .ps-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}
